import html2canvas from 'html2canvas';

/**
 * 将 DOM 元素导出为 PNG 图片并下载
 */
export async function exportElementAsPng(
  element: HTMLElement,
  filename: string,
  backgroundColor = '#1a1a1a'
): Promise<void> {
  const canvas = await html2canvas(element, {
    backgroundColor,
    scale: Math.min(window.devicePixelRatio || 2, 2),
    useCORS: true,
    logging: false,
  });
  const link = document.createElement('a');
  link.href = canvas.toDataURL('image/png', 1);
  link.download = `${filename}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * 将 SVG 代码字符串导出为 PNG 图片并下载
 * 通过 Blob URL → Image → Canvas 转 PNG，输出原始 SVG 尺寸
 */
export async function exportSvgCodeAsPng(
  svgCode: string,
  filename: string,
  backgroundColor = '#F7F9FC'
): Promise<void> {
  const svgBlob = new Blob([svgCode], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(svgBlob);

  const img = new Image();
  img.crossOrigin = 'anonymous';

  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('SVG 加载失败'));
    img.src = url;
  });

  const width = img.naturalWidth || img.width || 1200;
  const height = img.naturalHeight || img.height || 800;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context 不可用');

  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);

  URL.revokeObjectURL(url);

  const link = document.createElement('a');
  link.href = canvas.toDataURL('image/png', 1);
  link.download = `${filename}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
